import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("App crash:", error, info); }
  reset = (clear) => {
    if (clear) { try { localStorage.removeItem("xyz_workspace_v1"); } catch { /* ignore */ } }
    window.location.reload();
  };
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="invroom-gate" data-testid="app-error">
        <div className="ig-card">
          <div className="ig-brand">XYZ Ventures</div>
          <div className="ig-title">Something went wrong</div>
          <div className="ig-sub">The app hit an unexpected error while rendering. Your deals are safe in the Pipeline. Reload to try again, or reset the saved workspace if the problem persists.</div>
          <pre style={{ fontSize: 10.5, color: "var(--text3)", whiteSpace: "pre-wrap", maxHeight: 120, overflow: "auto" }}>{String(this.state.error?.message || this.state.error)}</pre>
          <button className="btn btn-primary" style={{ width: "100%", marginTop: 10 }} onClick={() => this.reset(false)} data-testid="app-error-reload">Reload</button>
          <button className="btn" style={{ width: "100%", marginTop: 8 }} onClick={() => this.reset(true)} data-testid="app-error-reset">Reset saved workspace & reload</button>
        </div>
      </div>
    );
  }
}
